import { User } from "src/app/services/response-models/user.response.model";

export class LoadUsers {
    static readonly type = "[Users] Set users";

    constructor(public payload: Array<User>) {}
}
